import React, { useContext, useState } from 'react'
import { InitializeContext } from '../../../App';
import aboutImg from '../../../assets/me/about.jpg';
import aboutImgBlur from '../../../assets/me/about-blur.jpg';
import { BiLogoTelegram, BiSupport } from 'react-icons/bi';
import { BsAward, BsBriefcase } from 'react-icons/bs';

const Fade = require("react-reveal/Fade");

export default function About() {
  const { theme } = useContext(InitializeContext);
  const [loaded, setLoaded] = useState<boolean>(false);

  return (
    <section id={'about'} className={`md:py-20 pb-10 md:pb-5 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'}`}>
      <div className="hero">
        <div className="hero-content flex-col justify-between lg:flex-row">
          <Fade bottom distance="20px">
            <div className="w-full md:w-2/3 lg:w-1/3 shadow-md rounded-3xl overflow-hidden">
              <div className="outline-none p-2 md:p-3">
                {
                  !loaded && (
                    <img
                      src={aboutImgBlur}
                      className="rounded-3xl w-full"
                      alt="Toufiq Hasan Kiron"
                    />
                  )
                }
                <img
                  src={aboutImg}
                  className="rounded-3xl w-full"
                  alt="Toufiq Hasan Kiron"
                  onLoad={() => {
                    setLoaded(true);
                  }
                  }
                  style={{ display: loaded ? 'block' : 'none' }}
                />
              </div>
            </div>
          </Fade>
          <Fade bottom distance="30px">
            <div className="md:w-2/3 lg:w-1/2 pt-5 md:pt-5 lg:pt-0 leading-loose">
              <small className="text-sm">
                VISIT MY PORTFOLIO & HIRE ME
              </small>.
              <h1 className="font-bestWishes text-2xl md:text-3xl font-bold leading-tight">
                About Me
              </h1>
              <p className="mb-2 mt-4">
                Meet <span className={`font-semibold duration-500 ${theme ? 'text-warning' : 'hover:text-primary'}`} title='Toufiq Hasan Kiron'>Toufiq Hasan Kiron</span>, a highly skilled full-stack developer and talented musician fondly known as <span className={`font-semibold duration-500 ${theme ? 'text-warning' : 'hover:text-primary'}`} title='Toufiq Hasan Kiron'>Kiron</span>. He was born on <span className={`font-semibold duration-500 ${theme ? '' : 'hover:text-primary'}`} title="Born on 15th July 2003">July 15, 2003</span> in Sonatola, Bogura and has made a remarkable impact in his fields.
              </p>
              <p>
                In 2023, he achieved his Diploma Program in <span className={`font-semibold duration-500 ${theme ? '' : 'hover:text-primary'}`}>Computer Technology</span> at <span className={`font-semibold duration-500 ${theme ? '' : 'hover:text-primary'}`}>Bogura Polytechnic Institute</span>, greatly enhancing his expertise and proficiency.
              </p>
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4 pt-3 md:pt-5 pb-3'>
                <div className={`flex flex-col justify-center items-center duration-300 hover:glass hover:text-white gap-2 ${theme ? 'bg-black hover:bg-warning' : 'bg-white hover:bg-primary'} py-4 rounded-xl shadow-md`}>
                  <BsAward />
                  <p className='text-sm font-semibold'>Experience</p>
                  <p className='text-xs'>1 year+ working</p>
                </div>
                <div className={`flex flex-col justify-center items-center duration-300 hover:glass hover:text-white gap-2 ${theme ? 'bg-black hover:bg-warning' : 'bg-white hover:bg-primary'} py-4 rounded-xl shadow-md`}>
                  <BsBriefcase />
                  <p className='text-sm font-semibold'>Completed</p>
                  <p className='text-xs'>75+ Project</p>
                </div>
                <div className={`flex flex-col justify-center items-center duration-300 hover:glass hover:text-white gap-2 ${theme ? 'bg-black hover:bg-warning' : 'bg-white hover:bg-primary'} py-4 rounded-xl shadow-md`}>
                  <BiSupport />
                  <p className='text-sm font-semibold'>Support</p>
                  <p className='text-xs'>Online 24/7</p>
                </div>
              </div>
              <div className='flex justify-center lg:justify-start items-center mt-2'>
                <a href={`https://drive.google.com/file/d/17g3kKlWFF9Msi4JjMZEMLkHGYNR0eeb3/view?usp=sharing`} target='_blank' rel="noreferrer" className={`flex items-center gap-2 border cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  View Resume <BiLogoTelegram />
                </a>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  )
}